// extracted by mini-css-extract-plugin
export default {"panelContainer":"Switchable_panelContainer__Zu3Yx","panel":"Switchable_panel__klJ+l"};